import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { st, Modal, MainView, Form, FormControl, FormSection, Button, CompanyMemberFullDecorator } from "lib/index";
import { stateSelector, close, fetchMember, updateMember, submit, removeMember, remindPassword } from "./index";

@connect(
  (state) => ({
    opened: stateSelector(state).opened,
    memberId: stateSelector(state).memberId,
    fetchDone: stateSelector(state).member.fetchDone,
    fetchLoading: stateSelector(state).member.fetchLoading,
    fetchFailed: stateSelector(state).member.fetchFailed,
    member: stateSelector(state).form.model || stateSelector(state).member.model,
    errors: stateSelector(state).form.errors,
    valid: stateSelector(state).form.valid,
    submitLoading: stateSelector(state).form.submitLoading || stateSelector(state).removal.fetchLoading,
    remindPasswordLoading: stateSelector(state).remindPassword.fetchLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        close,
        fetchMember,
        updateMember,
        submit,
        removeMember,
        remindPassword,
      },
      dispatch
    )
)
export default class EditCompanyMemberModal extends React.PureComponent {
  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  handleAdminUserPropChange(prop, value) {
    const { member, updateMember } = this.props;
    const nextMember = new CompanyMemberFullDecorator({
      ...member,
      [prop]: value,
      admin_user: {
        ...member.admin_user,
        [prop]: value,
      },
    });
    updateMember(nextMember);
  }

  handlePropChange(prop, value) {
    const { member, updateMember } = this.props;
    const nextMember = new CompanyMemberFullDecorator({
      ...member,
      [prop]: value,
    });
    updateMember(nextMember);
  }

  handleRemoveClick() {
    const { removeMember } = this.props;
    st.confirm({
      content: "Czy na pewno chcesz usunąć tego członka firmy?",
    }).then((yes) => yes && removeMember());
  }

  handleRemindPasswordClick() {
    this.props.remindPassword();
  }

  render() {
    const {
      opened,
      memberId,
      fetchLoading,
      fetchFailed,
      fetchDone,
      fetchMember,
      close,
      member,
      valid,
      errors,
      validate,
      submit,
      submitLoading,
      remindPasswordLoading,
    } = this.props;
    const roleOptions = st.authorize.managedMemberRoles().map((v) => [v, I18n.humanAttributeName("company_member", v)]);
    return (
      opened && (
        <Modal closeIcon closeOnDimmerClick={false} open onClose={() => close()}>
          <Modal.Header>
            {memberId
              ? I18n.t("papp.settings.EditCompanyMemberModal.edit_member_title")
              : I18n.t("papp.settings.EditCompanyMemberModal.new_member_title")}
          </Modal.Header>
          <Modal.Content>
            <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchMember} />
            {fetchDone && (
              <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
                {!member.id && (
                  <div className="fields inline">
                    <FormControl.InputFormGroup
                      {...FormControl.addProps(`admin_user.full_name`, { errors })}
                      value={member.admin_user.full_name}
                      onBlur={validate}
                      onChange={this.handleAdminUserPropChange.bind(this, "full_name")}
                      label={I18n.humanAttributeName("admin_user", "full_name")}
                      required
                    />

                    <FormControl.InputFormGroup
                      {...FormControl.addProps(`admin_user.email`, { errors })}
                      value={member.admin_user.email}
                      onBlur={validate}
                      onChange={this.handleAdminUserPropChange.bind(this, "email")}
                      label={I18n.humanAttributeName("admin_user", "email")}
                      type="email"
                      required
                    />
                  </div>
                )}

                <div className="fields inline">
                  {!!member.id && (
                    <FormControl.InputFormGroup
                      value={member.admin_user.full_name}
                      onChange={this.handlePropChange.bind(this, "admin_user")}
                      label={I18n.humanAttributeName("company_member", "admin_user")}
                      disabled
                    />
                  )}

                  <FormControl.SelectFormGroup
                    value={member.role}
                    onChange={this.handlePropChange.bind(this, "role")}
                    label={I18n.humanAttributeName("company_member", "role")}
                    options={roleOptions}
                    required
                  />
                </div>

                <button type="submit" disabled={submitLoading} hidden />
              </Form>
            )}
          </Modal.Content>
          {fetchDone && (
            <Modal.Actions>
              <Button as="a" floated="left" basic content={I18n.t("papp.common.cancel")} onClick={() => close()} />
              {!!member.id && (
                <Button
                  as="a"
                  floated="left"
                  basic
                  negative
                  content={I18n.t("papp.common.remove")}
                  onClick={this.handleRemoveClick.bind(this)}
                />
              )}
              {!!member.id && (
                <Button
                  as="a"
                  floated="left"
                  basic
                  content={I18n.t("papp.settings.EditCompanyMemberModal.remind_password")}
                  disabled={remindPasswordLoading}
                  onClick={this.handleRemindPasswordClick.bind(this)}
                />
              )}
              <Button
                as="a"
                primary
                content={I18n.t("papp.common.save")}
                disabled={!valid || submitLoading}
                onClick={submit}
              />
            </Modal.Actions>
          )}
        </Modal>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/EditCompanyMemberModal/EditCompanyMemberModal.jsx